import { render, staticRenderFns } from "./modal_detail_post.vue?vue&type=template&id=68ea34c9&scoped=true"
import script from "./modal_detail_post.vue?vue&type=script&lang=js"
export * from "./modal_detail_post.vue?vue&type=script&lang=js"
import style0 from "./modal_detail_post.vue?vue&type=style&index=0&id=68ea34c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ea34c9",
  null
  
)

export default component.exports